export async function getSession(id, platform, userToken = null, modelID = null) {
    try {
        const requestUrl = `https://api.creatorxone.com/session/?id=${id}&userToken=${userToken}&platform=${platform}&modelID=${modelID}&action=getSession`;
        const response = await fetch(requestUrl, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${import.meta.env.VITE_PUBLIC_API_TOKEN}`,
                'Content-Type': 'application/json',
            },
        });
        const responseData = await response.json();
        return responseData;
    } catch (error) {
        console.log(error);
        return error;
    }
}

export async function fetch_all_sessions_of_one_model(modelID, userToken, companyID = null, platform = null) {
    try {
        const requestUrl = `https://api.creatorxone.com/session/?modelID=${modelID}&action=getSessions&platform=${platform}&userToken=${userToken}`;
        const response = await fetch(requestUrl, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${import.meta.env.VITE_PUBLIC_API_TOKEN}`,
                'Content-Type': 'application/json',
            },
        });
        const responseData = await response.json();
        return responseData;
    } catch (error) {
        console.log(error);
        return error;
    }
}

export async function lockSession(id, lock, system, userToken, platform = null) {
    try {
        const requestObj = { id: id, platform: platform, action: lock ? "lock" : "unlock", system: system, userToken: userToken, onSessionToken: userToken };
        const response = await fetch(`https://api.creatorxone.com/session/`, {
            method: 'PATCH',
            headers: {
                'Authorization': `Bearer ${import.meta.env.VITE_PUBLIC_API_TOKEN}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(requestObj),
        });
        const responseData = await response.json();
        return responseData;
    } catch (error) {
        console.error('Error updating data:', error);
        throw error;
    }
}

export async function getModelProxy(modelID, userToken) {
    try {
        const requestUrl = `https://api.creatorxone.com/session/?proxy=1&modelID=${modelID}&userToken=${userToken}`;
        const response = await fetch(requestUrl, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${import.meta.env.VITE_PUBLIC_API_TOKEN}`,
                'Content-Type': 'application/json',
            },
        });
        const responseData = await response.json();
        return responseData.proxy ?? null;
    } catch (error) {
        console.log(error);
        return error;
    }
}

export async function deleteSession(id, model_id, userToken) {
    try {
        const requestUrl = `https://api.creatorxone.com/session/?id=${id}&modelID=${model_id}&userToken=${userToken}&action=deleteSession`;
        const response = await fetch(requestUrl, {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${import.meta.env.VITE_PUBLIC_API_TOKEN}`,
                'Content-Type': 'application/json',
            },
        });
        const responseData = await response.json();
        return responseData;
    } catch (error) {
        console.log(error);
        return error;
    }
}